import {TableToolbar, TableToolbarContent, TableBatchActions, DismissibleTag} from '@carbon/react';
import {SaveRosterButton} from './save-roster-button';

export interface ProviderTableToolbarProps {
    filters: any[];
    selection: string[];
    deselection: string[];
    revisionId: number;
    toolbarProps: any;
    batchActionProps: any;
    onFilterRemove: (filter: any) => void;
    onCancelSelection: () => void;
    onSaveRoster: () => Promise<void>;
    setSaveRosterModalOpen: (open: boolean) => void;
}

export function ProviderTableToolbar({
    filters,
    selection,
    deselection,
    revisionId,
    toolbarProps,
    batchActionProps,
    onFilterRemove,
    onCancelSelection,
    onSaveRoster,
    setSaveRosterModalOpen
}: ProviderTableToolbarProps) {
    const getBatchActionText = (id: string) => {
        if (id === 'carbon.table.batch.cancel') return 'Cancel';
        return `${selection.length ? `${selection.length} provider${selection.length > 1 ? 's' : ''} to add${deselection.length ? ', ' : ''}` : ''}${deselection.length ? `${deselection.length} provider${deselection.length > 1 ? 's' : ''} to remove` : ''}`;
    };

    return (
        <TableToolbar {...toolbarProps} size='sm' aria-label="data table toolbar">
            <TableToolbarContent>
                {filters && filters.map((filter: any, i: number) =>
                    <DismissibleTag
                        key={i}
                        onClose={() => onFilterRemove(filter)}
                        text={`${filter.variable.label} ${filter.test} ${filter.value}`}
                    />
                )}
            </TableToolbarContent>
            <TableBatchActions
                {...batchActionProps}
                shouldShowBatchActions={!!selection.length || !!deselection.length}
                translateWithId={getBatchActionText}
                totalSelected={selection.length + deselection.length}
                onCancel={onCancelSelection}
            >
                <SaveRosterButton
                    revisionId={revisionId}
                    setModalOpen={setSaveRosterModalOpen}
                    onUpdate={onSaveRoster}
                />
            </TableBatchActions>
        </TableToolbar>
    );
}
